// import { webConstants } from "@payping/utils/platformConstants";
// import React from "react";
// import { Button, Card, Col, Flex, Page, Row, SubNav, Typography } from "@payping/web-components";

// import FirstRow from "@/pages/OverviewTab/FirstRow";
// import SecondRow from "@/pages/OverviewTab/SecondRow";
// import styles from "@/assets/scss/SummationTab.module.scss";
// import { useAppTranslation } from "@/utils/useAppTranslation";

// const OverviewTab: React.FC = () => {
//   const { t } = useAppTranslation();

//   return (
//     <Page SubNav={<SubNav labels={[t("tabs.overview")]} />}>
//       <Row
//         // disabled for better readability
//         // eslint-disable-next-line sort-keys
//         gutter={[0, { xs: 16, md: 16, xl: 32 }]}
//         className={styles.container}
//       >
//         <Col span={24}>
//           <Card.Raw className={"p-1"}>
//             <Flex vertical gap={"middle"} justify={"center"} align={"center"}>
//               <Flex gap={"middle"} className={styles.containerTwo}>
//                 <img src={`${webConstants.STORAGE_URL}/img/home/notif.png`} width={100} alt={"bell-notification"} />
//               </Flex>

//               <Typography.Title level={5}>{t("redirectToNewDashboard.title")}</Typography.Title>
//               <Typography.Text>{t("redirectToNewDashboard.description")}</Typography.Text>
//               <a href={`https://newapp.${webConstants.MAIN_HOST}`} target={"_blank"} rel={"noreferrer"}>
//                 <Button type={"primary"}>{t("redirectToNewDashboard.cta")}</Button>
//               </a>
//             </Flex>
//           </Card.Raw>
//         </Col>
//         <Col span={24}>
//           <FirstRow />
//         </Col>
//         <Col span={24}>
//           <SecondRow />
//         </Col>
//       </Row>
//     </Page>
//   );
// };

import BannerNewApp from "@/pages/OverviewTab/bannerNewApp";
// export default OverviewTab;
import React from "react";
import { Col, Page, Row, SubNav } from "@payping/web-components";

import FirstRow from "@/pages/OverviewTab/FirstRow";
import SecondRow from "@/pages/OverviewTab/SecondRow";
import styles from "@/assets/scss/SummationTab.module.scss";
import { useAppTranslation } from "@/utils/useAppTranslation";

const OverviewTab: React.FC = () => {
  const { t } = useAppTranslation();

  return (
    <Page className="w-100" SubNav={<SubNav labels={[t("tabs.overview")]} />}>
      <Row
        // disabled for better readability
        // eslint-disable-next-line sort-keys
        gutter={[0, { xs: 16, md: 16, xl: 32 }]}
        className={styles.container}
      >
        <Col span={24}>
          <BannerNewApp />
        </Col>

        <Col span={24}>
          <FirstRow />
        </Col>
        <Col span={24}>
          <SecondRow />
        </Col>
      </Row>
    </Page>
  );
};

export default OverviewTab;
